import React from 'react'
import loader from "./assets/images/loading.gif"
function Loader({loadingText}) {
  return (
      <>
     <div className="page-loader">
  <img
    src={loader}
    alt="Loading..."
    className="loader-img"
  />
</div>

            {/* <p className="text-center" style={{ color: "grey" }}>
             {loadingText}
          </p> */}
      </>
  )
}

export default Loader